module.exports = __webpack_public_path__ + "img/insider_banner_mobile_2x.03422d73.png";